import { LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { RecaptchaModule } from "ng-recaptcha";

import { registerLocaleData } from "@angular/common";
import localeEnAu from "@angular/common/locales/en-AU";
registerLocaleData(localeEnAu);

import { AppRoutingModule } from "./app-routing.module";
import { FAWMaterialModule } from "./faw-material.module";

import { AppComponent } from "./app.component";
import { EnquirySubmittedComponent } from "./enquiry-submitted/enquiry-submitted.component";
import { EnquiryDetailComponent } from "./enquiry-detail/enquiry-detail.component";
import { EnquiryService } from "./shared/enquiry.service";
import { ValidationHelperService } from "./shared/validation-helper.service";

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FlexLayoutModule,
        HttpClientModule,
        ReactiveFormsModule,
        RecaptchaModule.forRoot(),

        AppRoutingModule,
        FAWMaterialModule,
    ],

    declarations: [
        AppComponent,
        EnquirySubmittedComponent,
        EnquiryDetailComponent,
    ],

    providers: [
        EnquiryService,
        ValidationHelperService,

        { provide: LOCALE_ID, useValue: "en-AU" }
    ],

    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app.module.ts